export default {
    funding: require('./icon_funding.svg'),
    offer: require('./icon_offer.svg'),

};


// WEBPACK FOOTER //
// ./src/components/RoadMap/RoadmapIcons.js